import { LoginTranslation } from '../../types/login.types';

export const login: LoginTranslation = {
  title: 'Bem-vindo ao Balcão',
  userLabel: 'USUÁRIO',
  userPlaceholder: 'Informe seu usuário',
  passwordLabel: 'SENHA',
  passwordPlaceholder: 'Informe sua senha',
  submit: 'ENTRAR',
  forgotPassword: 'Esqueci a senha',
  captchaRequired: 'Captcha é necessário!',
};

export default login;
